import { isEmpty, isInteger, isNumber } from 'lodash';

import {
  QUESTION_PROMPT_MAX_LENGTH,
  QUESTION_DESCRIPTION_PROMPT_MAX_LENGTH,
  MIN_DECIMALS_LIMIT,
  MAX_DECIMALS_LIMIT,
} from 'containers/QuestionnairePage/constants';
import { questionSupportsFeature } from 'utils/questionHelpers';
import {
  FEATURE_LIMIT_RANGE,
  FEATURE_DECIMAL_LIMIT,
  FEATURE_LIMIT_TEXT_LENGTH,
} from 'data/questionFeatures';
import { isDescriptionQuestionType } from 'utils/nodeTypes';

function validate({
  prompt,
  min,
  max,
  allowedDecimals,
  minLength,
  maxLength,
  type,
}) {
  const errors = {};
  const isMinValid = isNumber(min);
  const isMaxValid = isNumber(max);
  const isMinLengthValid = isInteger(minLength);
  const isMaxLengthValid = isInteger(maxLength);

  let promptMaxLength = QUESTION_PROMPT_MAX_LENGTH;
  if (isDescriptionQuestionType(type)) {
    promptMaxLength = QUESTION_DESCRIPTION_PROMPT_MAX_LENGTH;
  }

  if (isEmpty(prompt)) {
    errors.missingPrompt = true;
  }

  const questionTooLong = prompt && prompt.length > promptMaxLength;
  if (questionTooLong) {
    errors.questionTooLong = true;
  }

  const limitRange = isMinValid && isMaxValid;
  if (limitRange && questionSupportsFeature(type, FEATURE_LIMIT_RANGE)) {
    if (min >= max) {
      errors.minGreaterThanMax = true;
    }
  }

  const limitDecimalsEnabled = isNumber(allowedDecimals);
  if (
    limitDecimalsEnabled &&
    questionSupportsFeature(type, FEATURE_DECIMAL_LIMIT)
  ) {
    if (Number.isInteger(allowedDecimals)) {
      if (
        allowedDecimals < MIN_DECIMALS_LIMIT ||
        allowedDecimals > MAX_DECIMALS_LIMIT
      ) {
        errors.decimalLimitOutOfBounds = true;
      }
    } else {
      errors.decimalLimitMissingValue = true;
    }
  }

  const limitTextLength = isMinLengthValid && isMaxLengthValid;
  if (
    limitTextLength &&
    questionSupportsFeature(type, FEATURE_LIMIT_TEXT_LENGTH)
  ) {
    if (minLength >= maxLength) {
      errors.minGreaterThanMax = true;
    }
  }

  return errors;
}

export default validate;
